'use client'

import { clsx } from 'clsx'
import React, { useState } from 'react'

import { getFullName } from '@/_lib/utils'
import { SECTION_THEME_ENUM } from '@/_types/base'

import { IZSectionTeamCategoriesProps } from './_types/team-categories.types'
import ATeamCategoryFilters from './components/a-team-category-filters'
import ATeamCategoryGrid from './components/a-team-category-grid'
import ATeamCategoryHeader from './components/a-team-category-header'

const ZSectionTeamCategories: React.FC<IZSectionTeamCategoriesProps> = ({
	teamCategories,
	className = ''
}) => {
	const [searchQuery, setSearchQuery] = useState('')

	const handleSearchChange = (newSearchQuery: string) => {
		setSearchQuery(newSearchQuery)
	}

	const backgroundMap = {
		[SECTION_THEME_ENUM.WHITE]: 'bg-c0',
		[SECTION_THEME_ENUM.SAND]: 'bg-sand-02',
		[SECTION_THEME_ENUM.PURPLE]: 'bg-c17',
		[SECTION_THEME_ENUM.PURPLE_LIGHT]: 'bg-c1',
		[SECTION_THEME_ENUM.CYCLAMEN_LIGHT]: 'bg-c12',
		[SECTION_THEME_ENUM.FUCHSIA]: 'bg-c6',
		[SECTION_THEME_ENUM.TIRQUOISE]: 'bg-c18',
		[SECTION_THEME_ENUM.BLUE]: 'bg-c4',
		[SECTION_THEME_ENUM.CYCLAMEN]: 'bg-c11'
	}

	return (
		<>
			{teamCategories.map(teamCategory => {
				const filteredEmployees = teamCategory.employees?.filter(employee => {
					return getFullName(employee).toLowerCase().includes(searchQuery.toLowerCase())
				})

				return (
					<section
						key={teamCategory.slug}
						id={teamCategory.slug}
						className={clsx(
							'pt-5 pb-12 md:pt-16 md:pb-24',
							backgroundMap[teamCategory.sectionTheme as keyof typeof backgroundMap],
							className
						)}
					>
						<div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8 lg:py-14'>
							<ATeamCategoryHeader
								title={teamCategory.sectionTitle}
								description={teamCategory.sectionText}
								sectionTheme={teamCategory.sectionTheme}
							/>
						</div>

						<div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
							<ATeamCategoryFilters
								teamCategory={teamCategory}
								teamCategories={teamCategories}
								onSearchChange={handleSearchChange}
								searchQuery={searchQuery}
							/>

							<ATeamCategoryGrid
								employees={filteredEmployees}
								hasEmployees={!!teamCategory.employees?.length}
								categorySlug={teamCategory.slug}
							/>
						</div>
					</section>
				)
			})}
		</>
	)
}

export default ZSectionTeamCategories
